import React from "react";

const TextInput = ({ label, value, onChange, placeholder, width, style, onFocus }) => {
  const id = label.replace(" ", "-");
  return (
    <div className="si-c-property-input layout-default" style={style}>
      <label className="si-c-label" htmlFor={id}>
        {label}
      </label>
      <input
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus || (({ target }) => target.select())}
        id={id}
        style={{ flex: 1, height: "31px", width: width || "100%" }}
        className="si-c-control"
        type="text"
      />
    </div>
  );
};

export default TextInput;
